import __base_store from '@/store/__base_store'

/**
 * Store de conceptos de movimiento de stock (modelo `concepto_stock_movement`) construido desde el factory común.
 */
export default __base_store({
	state: {
		model_name: 'concepto_stock_movement',
	},
})

